import { render, staticRenderFns } from "./NotificacionFormTabImplicados.vue?vue&type=template&id=10240a9a"
import script from "./NotificacionFormTabImplicados.vue?vue&type=script&lang=js"
export * from "./NotificacionFormTabImplicados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports